import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { GridGetForSignatureRequestsPayload } from 'Interfaces/Grid';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: GridGetForSignatureRequestsPayload) =>
    $actions.grid.getGridForSignatureRequests(dispatch, payload),
  );
};
